import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

function UserAccounts() {
  return <Layout><Outlet /></Layout>;
}

export default UserAccounts;
